var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { StyledCardContainer } from './Card.styles';
import { useDeprecation } from '../../effects/Deprecation';
export var Card = React.forwardRef(function Card(_a, ref) {
    var children = _a.children, level = _a.level, _b = _a.shadowStrength, shadowStrength = _b === void 0 ? 1 : _b, variant = _a.variant, props = __rest(_a, ["children", "level", "shadowStrength", "variant"]);
    useDeprecation({
        when: level,
        oldThing: 'level',
        newThing: 'shadowStrength',
    });
    return (React.createElement(StyledCardContainer, __assign({}, props, { "$level": level, "$shadowStrength": shadowStrength, "$variant": variant, ref: ref }), children));
});
Card.displayName = 'Card';
//# sourceMappingURL=Card.js.map